/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Push_UnsupportedInputs */

const en_settings_push_unsupported = /** @type {(inputs: Settings_Push_UnsupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This browser can’t do web push. On iPhone, first add this site to your Home Screen (Share → “Add to Home Screen”), open it from there, then come back to enable notifications.`)
};

const he_settings_push_unsupported = /** @type {(inputs: Settings_Push_UnsupportedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`הדפדפן הזה לא תומך ב-web push. באייפון, הוסף תחילה את האתר למסך הבית (שיתוף ← „הוסף למסך הבית”), פתח אותו משם, ואז חזור כדי להפעיל התראות.`)
};

/**
* | output |
* | --- |
* | "This browser can’t do web push. On iPhone, first add this site to your Home Screen (Share → “Add to Home Screen”), open it from there, then come back to enab..." |
*
* @param {Settings_Push_UnsupportedInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const settings_push_unsupported = /** @type {((inputs?: Settings_Push_UnsupportedInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Push_UnsupportedInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_push_unsupported(inputs)
	return he_settings_push_unsupported(inputs)
});